"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockPriceFeed__factory = void 0;
var ethers_1 = require("ethers");
var MockPriceFeed__factory = /** @class */ (function (_super) {
    __extends(MockPriceFeed__factory, _super);
    function MockPriceFeed__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    MockPriceFeed__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    MockPriceFeed__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    MockPriceFeed__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    MockPriceFeed__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    MockPriceFeed__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    return MockPriceFeed__factory;
}(ethers_1.ContractFactory));
exports.MockPriceFeed__factory = MockPriceFeed__factory;
var _abi = [
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "symbol",
                type: "bytes32",
            },
        ],
        name: "getPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "symbol",
                type: "bytes32",
            },
            {
                internalType: "uint256",
                name: "value",
                type: "uint256",
            },
        ],
        name: "setPrice",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b506102c0806100206000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c806310d8d74d1461003b57806331d98b3f14610057575b600080fd5b61005560048036038101906100509190610165565b610087565b005b610071600480360381019061006c919061013c565b6100a2565b60405161007e91906101f3565b60405180910390f35b80600080848152602001908152602001600020819055505050565b60008060008084815260200190815260200160002054116100f8576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016100ef906101d3565b60405180910390fd5b600080838152602001908152602001600020549050919050565b6000813590506101218161025c565b92915050565b60008135905061013681610273565b92915050565b60006020828403121561014e57600080fd5b600061015c84828501610112565b91505092915050565b6000806040838503121561017857600080fd5b600061018685828601610112565b925050602061019785828601610127565b9150509250929050565b60006101ae60208361020e565b91506101b982610233565b602082019050919050565b6101cd81610229565b82525050565b600060208201905081810360008301526101ec816101a1565b9050919050565b600060208201905061020860008301846101c4565b92915050565b600082825260208201905092915050565b6000819050919050565b6000819050919050565b7f4e6f2070726963696e67206461746120666f7220676976656e2073796d626f6c600082015250565b6102658161021f565b811461027057600080fd5b50565b61027c81610229565b811461028757600080fd5b5056fea26469706673582212204073dc6465d6bee42438cd37ce7dff6442fa9d57c4ab4d58285cf4fe42d9a6e364736f6c63430008020033";
//# sourceMappingURL=MockPriceFeed__factory.js.map